import {ILobbyCategory} from "@/lib/types/games/ILobbyCategory";
import {LobbyCategoryTypeEnum} from "@/lib/enums/LobbyCategoryTypeEnum";

// AC-819: slug → sprite icon name (see app/components/common/Icon.tsx).
// A category created in the backoffice with an unknown slug falls back to the
// slots icon.
const CATEGORY_ICONS: Record<string, string> = {
    'slots': 'slots',
    'popular': 'popular',
    'fast-games': 'stopwatch',
    'live-casino': 'liveCasino',
    'blackjack': 'blackjack',
    'roulette': 'roulette',
    'game-shows': 'gameShows',
    'baccarat': 'baccarat',
    'providers': 'users',
    'latest-releases': 'latestReleases',
    'table-games': 'tableGames',
};

export const categoryIconName = (slug: string): string => CATEGORY_ICONS[slug] || 'slots';

const kebabToCamel = (slug: string) => slug.replace(/-([a-z0-9])/g, (_, char: string) => char.toUpperCase());

// Localized label key candidate for a category slug; callers must check
// t.has() and fall back to the backend title for unknown slugs.
export const categoryLabelKey = (slug: string): string => `MenuItems.${kebabToCamel(slug)}`;

// Shown until GET /categories responds (and if it errors) — mirrors the
// pre-AC-819 hardcoded lobby so the page never renders empty.
export const FALLBACK_LOBBY_CATEGORIES: ILobbyCategory[] = [
    {id: 'slots', slug: 'slots', title: 'Slots', type: LobbyCategoryTypeEnum.STANDARD, contentMode: 'AUTO', displayOrder: 0},
    {id: 'latest-releases', slug: 'latest-releases', title: 'Latest Releases', type: LobbyCategoryTypeEnum.STANDARD, contentMode: 'AUTO', displayOrder: 1},
    {id: 'game-shows', slug: 'game-shows', title: 'Game Shows', type: LobbyCategoryTypeEnum.STANDARD, contentMode: 'AUTO', displayOrder: 2},
    {id: 'live-casino', slug: 'live-casino', title: 'Live Casino', type: LobbyCategoryTypeEnum.STANDARD, contentMode: 'AUTO', displayOrder: 3},
    {id: 'providers', slug: 'providers', title: 'Providers', type: LobbyCategoryTypeEnum.PROVIDERS, contentMode: 'AUTO', displayOrder: 4},
];
